import { FlexCell, FlexRow, Rating } from '@epam/loveship'

type RatingReadOnlyProps = {
  value: number
}

export const RatingReadOnly = ({ value }: RatingReadOnlyProps) => {
  return (
    <FlexRow>
      <FlexCell width="auto">
        <Rating value={value} isReadonly onValueChange={() => undefined} />
      </FlexCell>
    </FlexRow>
  )
}
